// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__mN13u","fileBtn":"File_fileBtn__22mSW","closeBtn":"File_closeBtn__3fSaq","fileSelected":"File_fileSelected__1kTo2","disabled":"File_disabled__1pFT4"};